// src/VideoPlayer.js
import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography, Slider, Button } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import FavoriteBorderIcon from "@mui/icons-material/Favorite";
import CommentIcon from "@mui/icons-material/Comment";
import ShareIcon from "@mui/icons-material/Share";
import GetAppIcon from "@mui/icons-material/GetApp";
import CloseIcon from "@mui/icons-material/Close";
import Avatar from "@mui/material/Avatar";
import { fetchData } from "./functions/functions";
import { Favorite } from "@mui/icons-material";
import { detectDevice } from "./utils/deviceDetection";
import ReactPlayer from "react-player";
import { ImagePrefix } from "./functions/client";
var CryptoJS = require("crypto-js");

const VideoPlayer = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const content_id = urlParams.get("id");
  const fixedId = content_id.replace(/ /g, "+");

  var bytes = CryptoJS.AES.decrypt(fixedId, process.env.REACT_APP_SECRET_KEY);
  var originalText = bytes.toString(CryptoJS.enc.Utf8);

  const [content, setContent] = useState(undefined);
  const [showAppBanner, setShowAppBanner] = useState(true);
  const [device, setDevice] = useState(null);

  useEffect(() => {
    // Detect device type
    const detectedDevice = detectDevice("NextFriend");
    setDevice(detectedDevice);

    // console.log(originalText);
    // if (originalText) {
    fetchData(originalText)
      .then((result) => {
        setContent(result);
      })
      .catch((e) => {
        alert(e?.response?.data?.message);
      });
    // }
  }, [originalText]);

  const handleDownloadApp = () => {
    if (device && device.storeUrl) {
      console.log(device.storeUrl, "store url");

      // For real devices, this will open the native app store
      // For simulators/emulators, this might not work but will work on real devices
      try {
        window.location.href = device.storeUrl;
      } catch (error) {
        // Fallback: open in new tab if direct navigation fails
        console.log("Direct navigation failed, opening in new tab");
        window.open(device.storeUrl, "_blank");
      }
    }
  };

  const closeBanner = () => {
    setShowAppBanner(false);
  };

  return (
    // <div
    //   style={{
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     height: "100vh",
    //     width: "100vw",
    //     position: "fixed", // Make the div fixed to the viewport
    //     top: 0,
    //     left: 0,
    //     backgroundColor: "black", // Optional: Add background color for better visibility
    //   }}
    // >
    //   {object ? (
    //     <video width="440" controls poster={object.thumbnail}>
    //       <source
    //         src={
    //           "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
    //         }
    //         type="video/mp4"
    //       />
    //       Your browser does not support the video tag.
    //     </video>
    //   ) : (
    //     <h2>No video selected</h2>
    //   )}
    // </div>
    content ? (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100vw",
          backgroundColor: "black",
          //color: "white",
          position: "relative",
          flexDirection: "column",
          //overflow: "hidden",
        }}
      >
        {/* App Download Banner */}
        {showAppBanner && device && device.type !== "other" && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: "rgba(0, 0, 0, 0.9)",
              backdropFilter: "blur(10px)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
              <Box
                sx={{
                  marginRight: "12px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src="/nextfriend_logo.svg"
                  alt="NextFriend Logo"
                  width="32"
                  height="32"
                />
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ color: "white", fontWeight: 600, marginBottom: "2px" }}
                >
                  Get the NextFriend App
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                >
                  Better experience on mobile
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<GetAppIcon />}
                onClick={handleDownloadApp}
                sx={{
                  backgroundColor: "#6E41BF",
                  color: "white",
                  textTransform: "none",
                  borderRadius: "20px",
                  fontSize: "12px",
                  padding: "6px 16px",
                  "&:hover": {
                    backgroundColor: "#6E41BF",
                  },
                }}
              >
                Download
              </Button>

              <IconButton
                size="small"
                onClick={closeBanner}
                sx={{ color: "rgba(255, 255, 255, 0.7)" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        )}
        {/* Top Speaker Icon */}
        {/* <Box sx={{ position: "absolute", top: 20, right: 20 }}>
        <IconButton color="inherit">
          <VolumeUpIcon />
        </IconButton>
      </Box> */}

        {/* Video Section */}
        <Box sx={{ position: "relative", width: "100%" }}>
          {content.type.split("/")[0] === "video" ? (
            <ReactPlayer
              url={ImagePrefix + "/" + content.uri}
              controls
              width={"100%"}
              height={"100%"}
              playing={true} // Add this for autoplay
              muted={true} // Often required for autoplay to work
            />
          ) : (
            <img
              src={ImagePrefix + "/" + content.uri}
              alt="content"
              width="100%"
            />
          )}
          {/* Bottom Icons

      {/* Seek Bar */}
          {/* <Slider
          defaultValue={0}
          aria-label="Video Progress"
          sx={{
            color: "white",
            mt: 1,
            width: "100%",
          }}
        /> */}
        </Box>
        <Box
          // sx={{
          //   display: "flex",
          //   backgroundColor: "red",
          //   alignItems: "center",
          //   mt: 2,
          //   alignSelf: "flex-end",
          // }}
          sx={{
            display: "flex",
            flexDirection: "column", // Arrange items vertically
            alignItems: "center",
            //mt: 2,
            position: "absolute", // Fix the box to a position
            //top: "50%", // Center vertically in the view
            right: 20, // Align to the right side with a 20px gap
            //transform: "translateY(-50%)", // Center the box perfectly on the vertical axis
            bottom: "12%",
          }}
        >
          <Box
            sx={{
              width: 43,
              height: 43,
              borderRadius: 100,
              backgroundColor: "white",
              display: "flex", // Enable flex layout
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 100,
                backgroundColor: "grey",
                display: "flex", // Enable flex layout
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="subtitle2" sx={{ color: "white" }}>
                {content.user.firstName.charAt(0)}
              </Typography>
            </Box>
          </Box>
          <IconButton sx={{ color: "white" }}>
            <Favorite />
          </IconButton>
          <Typography variant="subtitle2" sx={{ color: "white" }}>
            {content.likeCount}
          </Typography>
          <IconButton sx={{ color: "white" }}>
            <CommentIcon />
          </IconButton>
          <Typography variant="subtitle2" sx={{ color: "white" }}>
            {content.commentCount}
          </Typography>
          <IconButton sx={{ color: "white" }}>
            <ShareIcon />
          </IconButton>
        </Box>

        <Box sx={{ position: "absolute", left: 20, bottom: "12%" }}>
          <Typography variant="h6" sx={{ mt: 1, color: "white" }}>
            {content.caption}
          </Typography>

          {/* <Typography variant="subtitle2" sx={{ mt: 1, color: "white" }}>
            See translation
          </Typography> */}
        </Box>
      </Box>
    ) : (
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography sx={{ textAlign: "center" }} variant="h3">
          No video selected
        </Typography>
      </Box>
    )
  );
};

export default VideoPlayer;
